import { useEffect, useState } from "react";
import { useAppSelector } from "../store";
import { get } from "./api";
import { ENDPOINTS } from "./constants";

// Giriş yapmış kullanıcının seviye bilgisi; kenar çubuğu, akış ve kutlama penceresi aynı veriyi paylaşır.
const REFRESH_MS = 60 * 1000;
const state = { username: null, data: null, fetchedAt: 0, pending: null };
const listeners = new Set();

const publish = () => listeners.forEach((listener) => listener(state.data));

export const refreshMyRank = async (username, force = false) => {
  if (!username) return null;
  if (state.username !== username) {
    state.username = username;
    state.data = null;
    state.fetchedAt = 0;
  }
  if (!force && state.data && Date.now() - state.fetchedAt < REFRESH_MS) return state.data;
  if (!state.pending) {
    state.pending = get(`${ENDPOINTS.RANKS}?me=1`)
      .then((response) => {
        if (response?.my_rank && state.username === username) {
          state.data = response.my_rank;
          state.fetchedAt = Date.now();
          publish();
        }
        return state.data;
      })
      .catch(() => state.data)
      .finally(() => {
        state.pending = null;
      });
  }
  return state.pending;
};

export default function useMyRank(refreshKey) {
  const username = useAppSelector((s) => s.auth.currentUser?.username);
  const [rank, setRank] = useState(username && state.username === username ? state.data : null);

  useEffect(() => {
    listeners.add(setRank);
    return () => listeners.delete(setRank);
  }, []);

  useEffect(() => {
    if (!username) {
      setRank(null);
      return;
    }
    refreshMyRank(username);
  }, [username, refreshKey]);

  return username ? rank : null;
}

export const rankProgress = (rank) => {
  if (!rank?.next_rank) return 100;
  const span = (rank.next_rank.min_score || 1) - (rank.min_score || 0);
  return Math.max(0, Math.min(100, ((rank.score - (rank.min_score || 0)) / span) * 100));
};
